import { render, staticRenderFns } from "./Page-Messaging.vue?vue&type=template&id=4da75e04&"
import script from "./Page-Messaging.vue?vue&type=script&lang=js&"
export * from "./Page-Messaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports